<template>
    <div
        class="l-ss-c-widget-voice-popup">
        <popup
            v-if="$configuration.features.voiceSearch"
            :opened="store.state.ui.isVoiceSearchActive"
            class="l-ss-c-search-popup-voice-search-popup"
            @close="closeVoicePopup">
            <voice-search-container :store="store"/>
        </popup>
    </div>
</template>
<script>
    import VoiceSearchContainer from '@/core/components/voice-search-container.vue';
    import RootComponentMixin from '../core/mixins/root-component';
    import Popup from '../core/components/popup';

    export default {
        components: {
            VoiceSearchContainer,
            Popup,
        },
        provide: RootComponentMixin.provide,
        props: {
            ...RootComponentMixin.props,
        },
        watch: {
            'store.state.ui.isVoiceSearchActive'(value) {
                if (value) {
                    this.handleOpenVoicePopup();
                } else {
                    this.handleCloseVoicePopup();
                }
            },
        },
        methods: {
            handleOpenVoicePopup() {
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchLoader', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });

                this.$emit('voice-search', true);
            },
            handleCloseVoicePopup() {
                this.$emit('voice-search', false);
            },
            closeVoicePopup() {
                this.$emit('close');
                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isVoiceSearchActive',
                    value: false,
                });
            },
        },
    };
</script>
